// @flow
import * as React from 'react';
// $FlowIssue
import { useState, useEffect, useRef } from 'react';
import url from 'url';
import { EmptyCard } from 'components';

function proxySAMLRequest({ SAMLRequest, RelayState, token }) {
  return fetch(
    `/socialcollection/generate-saml?SAMLRequest=${encodeURIComponent(
      SAMLRequest
    )}&RelayState=${RelayState}`,
    {
      headers: {
        Authorization: token,
      },
    }
  )
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        throw new Error();
      }
    })
    .then(response => {
      if (typeof response === 'string') {
        return response;
      } else {
        throw new Error();
      }
    });
}

export function WyngSingleSignOn({
  queryString,
  token,
}: {
  queryString: string,
  token: string,
}) {
  const [{ SAMLRequest, RelayState }] = useState(() => {
    const { query: { SAMLRequest, RelayState } = {} } = url.parse(
      queryString,
      true
    );
    return { SAMLRequest, RelayState };
  });
  const [error, setError] = useState(() => {
    if (!SAMLRequest || !RelayState) {
      return true;
    }
    return false;
  });
  const [SAMLResponse, setSAMLResponse] = useState();
  const formRef = useRef();
  console.log({ queryString, SAMLRequest, RelayState });

  useEffect(() => {
    proxySAMLRequest({ SAMLRequest, RelayState, token })
      .then(response => {
        setSAMLResponse(response);
      })
      .catch(() => {
        setError(true);
      });
  }, []);

  useEffect(() => {
    formRef.current && formRef.current.submit();
  }, [SAMLResponse]);

  if (error) {
    return (
      <EmptyCard
        title="Social Collection"
        message="There was an error logging you into Social Collection. If this error persists, contact PowerReviews Support."
      />
    );
  }

  if (RelayState && SAMLResponse) {
    return (
      <form
        className="dn"
        ref={formRef}
        method="post"
        action="https://wyng.com/auth/complete/saml/"
      >
        <input type="hidden" name="RelayState" defaultValue={RelayState} />
        <input type="hidden" name="SAMLResponse" defaultValue={SAMLResponse} />
      </form>
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/containers/socialcollection/WyngSingleSignOn.js